// 403 codes the deals and contracts services answer when the caller's role
// limits which records it may edit.
const EDIT_RESTRICTION_MESSAGE_KEYS: Record<string, string> = {
  deal_not_assigned: "common.editRestrictions.notAssigned",
  contract_not_assigned: "common.editRestrictions.notAssigned",
  closed_deal_read_only: "common.editRestrictions.closedDealReadOnly",
  close_won_not_permitted: "deals.dealView.closeWonNotPermitted"
};

// The services render a raised HTTPException as the plain-text body
// "<status> <detail>", not as JSON.
const PLAIN_TEXT_PREFIX = "403 ";

interface EditRestrictionResponse {
  status?: number;
  data?: unknown;
}

interface EditRestrictionError {
  response?: EditRestrictionResponse;
}

/** The translation key for an edit-restriction 403, or undefined for any other error. */
export const editRestrictionMessageKey = (error: unknown): string | undefined => {
  const response = (error as EditRestrictionError | undefined)?.response;
  if (response?.status !== 403 || typeof response.data !== "string") {
    return undefined;
  }
  if (!response.data.startsWith(PLAIN_TEXT_PREFIX)) return undefined;
  const code = response.data.slice(PLAIN_TEXT_PREFIX.length).trim();
  return Object.prototype.hasOwnProperty.call(EDIT_RESTRICTION_MESSAGE_KEYS, code)
    ? EDIT_RESTRICTION_MESSAGE_KEYS[code]
    : undefined;
};
